import { CSSObject } from "@emotion/react";
import { constants } from "@newsela/angelou";

const {
  colors: { ui },
} = constants;

export const barCssForDouble: CSSObject = {
  height: "90px",
  width: "100%",
  borderRadius: "0px 8px 0px 0px",
  marginRight: "9px",
  minWidth: "4px",
};

export const loadingShimmerCss: CSSObject = {
  borderRadius: "0px 8px 0px 0px",
};
export const widgetTripleBarContainerCss: CSSObject = {
  display: "grid",
  gridTemplateAreas: `
    "topLeft topCenter"
    "middleLeft middleCenter"
    "bottomLeft bottomCenter"
  `,
  gridTemplateColumns: "1fr 2fr",
  gridTemplateRows: "1fr 1fr 1fr",
  gap: "8px 9px",
  padding: "12px 12px 10px",
  height: "100%",
  alignItems: "center",
  borderRadius: "1rem",
};

export const widgetDoubleBarsContainerCss: CSSObject = {
  display: "grid",
  gridTemplateAreas: `
      "topLeft topCenter"
      "middleLeft middleCenter"
  `,
  gridTemplateColumns: "1fr 2fr",
  gridTemplateRows: "1fr 1fr",
  gap: "8px 9px",
  padding: "12px 12px 10px",
  height: "100%",
  alignItems: "center",
  borderRadius: "1rem",
};

export const labelCss: CSSObject = {
  fontSize: "1rem",
  color: ui.neutral[700],
  justifySelf: "end",
  textAlign: "end",
};

export const labelOneCss: CSSObject = {
  gridArea: "topLeft",
};

export const labelTwoCss: CSSObject = {
  gridArea: "middleLeft",
};

export const labelThreeCss: CSSObject = {
  gridArea: "bottomLeft",
};

export const loadingContainer: CSSObject = {
  display: "contents",
};

export const barCss: CSSObject = {
  height: "58px",
  width: "100%",
  borderRadius: "0px 8px 0px 0px",
  marginRight: "9px",
  minWidth: "4px",
};

export const barValueContainerOneCss: CSSObject = {
  gridArea: "topCenter",
  display: "flex",
};

export const barValueContainerTwoCss: CSSObject = {
  gridArea: "middleCenter",
  display: "flex",
};

export const barValueContainerThreeCss: CSSObject = {
  gridArea: "bottomCenter",
  display: "flex",
};

export const barOneCss = (heightOfBarOne: number) => {
  return {
    // TO DO: SWAP WITH ANGELOU COLORS
    backgroundColor: "#48C8E4",
    width: heightOfBarOne === 0 ? "4px" : `${heightOfBarOne}%`,
  };
};

export const barTwoCss = (heightOfBarTwo: number) => {
  return {
    // TO DO: SWAP WITH ANGELOU COLORS
    backgroundColor: "#34A1B9",
    width: heightOfBarTwo === 0 ? "4px" : `${heightOfBarTwo}%`,
  };
};

export const barThreeCss = (heightOfBarThree: number) => {
  return {
    backgroundColor: ui.teal[700],
    width: heightOfBarThree === 0 ? "4px" : `${heightOfBarThree}%`,
  };
};

export const valueCss: CSSObject = {
  color: ui.teal[700],
  fontWeight: "bold",
  marginBottom: ".5rem",
  fontSize: "1.25rem",
  alignContent: "center",
};
